export const baseMutations = {
    all(state, payload) {
        state[payload.resource].items = payload.result;
    },
    add(state, payload) {
        state[payload.resource].items.push(payload.result);
    },
    find(state, payload) {
        state.selectedId = payload.result.id;
        state[payload.resource].item = payload.result;
        var item = state[payload.resource].items.filter(({id}) => id == payload.result.id);
        
        if(item.length == 0) {
            baseMutations.add(state,payload);
        }
        
    },
    update(state, payload) {
        var item = state[payload.resource].items.filter(({id}) => id == payload.result.id);
        if(item != undefined) {
            var index = state[payload.resource].items.indexOf(item[0]);
            var currentItem = state[payload.resource].items[index];
            if(currentItem != undefined) {
                Object.keys(payload.result).forEach(key => {
                    currentItem[key] = payload.result[key]
                });
            }
        }
    },
    delete(state,payload) {
        var item = state[payload.resource].items.filter(({id}) => id == payload.id);
        if(item != undefined) {
            state[payload.resource].items.splice(state[payload.resource].items.indexOf(item[0]), 1);
        }
    }
}